// Últimas búsquedas de la página de búsqueda de productos, en este navegador.
//
// Una lista por usuario y tienda: en las tiendas varios vendedores comparten
// ordenador, y lo buscado en USA no tiene sentido en CR. Son pocas cadenas
// cortas, así que basta localStorage (IndexedDB compensaría con miles).
// Sin almacenamiento (modo privado, bloqueado) simplemente no hay recientes.

const MAX_RECENTS = 10;

const storageKey = (userKey, storeCode) =>
  `partSearch.recent.${userKey || "anon"}.${storeCode || "none"}`;

export const readRecents = (userKey, storeCode) => {
  try {
    const list = JSON.parse(
      window.localStorage.getItem(storageKey(userKey, storeCode)) || "[]"
    );
    return Array.isArray(list) ? list.filter(v => typeof v === "string") : [];
  } catch {
    return [];
  }
};

const write = (userKey, storeCode, list) => {
  try {
    window.localStorage.setItem(
      storageKey(userKey, storeCode),
      JSON.stringify(list)
    );
  } catch {
    // Sin almacenamiento sólo se pierde el historial.
  }
  return list;
};

/** La pone la primera (sin repetir, sin distinguir mayúsculas). */
export const addRecent = (userKey, storeCode, query) => {
  const text = String(query || "").trim();
  if (text.length < 2) return readRecents(userKey, storeCode);
  const list = readRecents(userKey, storeCode).filter(
    item => item.toLowerCase() !== text.toLowerCase()
  );
  return write(userKey, storeCode, [text, ...list].slice(0, MAX_RECENTS));
};

export const removeRecent = (userKey, storeCode, query) =>
  write(
    userKey,
    storeCode,
    readRecents(userKey, storeCode).filter(item => item !== query)
  );

export const clearRecents = (userKey, storeCode) =>
  write(userKey, storeCode, []);
